import { SIGNAL_FILTER_FIELDS } from './filter-fields';
import type { FlowLayoutTable, FlowListLayoutSpec } from './flow-layouts/schema';
import { SIGNAL_COLUMN_FILTER_ALIASES } from './signal-view';

/**
 * The header for a column whose cell stacks several fields, per the layout's
 * `columnStacks`: `text` is the label plus the short part names, and
 * `filterLabels` are the filter-catalog labels of each stacked field (for the
 * '?' tooltip). Undefined when the layout declares no stack for the column.
 * Lives outside `flow-layouts/` so importing the filter catalog closes no cycle
 * (view.ts imports the flow-layouts barrel).
 */
export function columnStackHeader(
  spec: FlowListLayoutSpec,
  table: FlowLayoutTable,
  columnKey: string,
  label: string,
): { text: string; filterLabels: string[] } | undefined {
  if (table !== 'signals') return undefined;
  const parts = spec.columnStacks?.[table]?.[columnKey];
  if (!parts || parts.length === 0) return undefined;
  const labelOf = (key: string): string | undefined => SIGNAL_FILTER_FIELDS.find(f => f.key === key)?.label;
  const filterLabels = parts.flatMap(part => {
    const direct = labelOf(part.key);
    if (direct !== undefined) return [direct];
    const alias = SIGNAL_COLUMN_FILTER_ALIASES.find(a => a.columnKey === part.key);
    return alias ? alias.targets.flatMap(t => labelOf(t) ?? []) : [];
  });
  const text = parts.length >= 2 ? `${label} (${parts.map(p => p.short).join('/')})` : label;
  return { text, filterLabels };
}
